import { render, staticRenderFns } from "./betlist.vue?vue&type=template&id=07bfd4aa&scoped=true"
import script from "./betlist.vue?vue&type=script&lang=js"
export * from "./betlist.vue?vue&type=script&lang=js"
import style0 from "./betlist.vue?vue&type=style&index=0&id=07bfd4aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfd4aa",
  null
  
)

export default component.exports